import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { LineChart } from '@mui/x-charts';
import CheckboxIconMenu from './CheckboxIconMenu';
import { chartColors, lineChartGradientColors } from '../helpers/dashboardColors';

const options = ['Selected', 'Interviewed', 'Joined', 'Goal', 'Candidates Added'];
const initialSelected = ['Selected', 'Interviewed', 'Joined'];

const MonthlyTrendsChart = ({ monthlyTrendsData }) => {
    const [selectedChartOptions, setSelectedChartOptions] = useState(['Selected', 'Interviewed', 'Joined']);

    // Prepare mothly trends chart data
    const cpMonths = monthlyTrendsData?.map(d => d.month);
    const cpTotalSelected = monthlyTrendsData?.map(d => d.total_selected);
    const cpInterviewed = monthlyTrendsData?.map(d => d.total_interviewed);
    const cpJoined = monthlyTrendsData?.map(d => d.total_joined);
    const cpGoal = monthlyTrendsData?.map(d => d.goal);
    const cpCandidatesAdded = monthlyTrendsData?.map(d => d.total_candidates_added);

    const monthlyTrendsDataPoints = [
        {
            data: cpInterviewed,
            label: "Interviewed",
            color: chartColors[4],
            // area: true
        },
        {
            data: cpTotalSelected,
            label: "Selected",
            color: chartColors[1],
            // area: true
        },
        {
            data: cpJoined,
            label: "Joined",
            color: chartColors[2],
            // area: true
        },
        {
            data: cpGoal,
            label: "Goal",
            color: chartColors[3],
            id: 'goal'
            // area: true
        },
        {
            data: cpCandidatesAdded,
            label: "Candidates Added",
            color: chartColors[0],
            // area: true
        },
    ];

    const filteredMonthlyTrendsDataPoints = monthlyTrendsDataPoints.filter(d => selectedChartOptions.includes(d.label));

    const handleMonthlyDataPointChange = (data) => {
        setSelectedChartOptions(data);
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <Typography variant='h6' sx={{ fontWeight: 'bold', color: '#3d3d3d', padding: '8px 0', marginLeft: '8px' }}>Monthly Trends</Typography>
                <CheckboxIconMenu options={options} initialSelected={initialSelected} onChange={handleMonthlyDataPointChange} style={{ marginRight: '8px' }} />
            </Box>
            {monthlyTrendsData && monthlyTrendsData.length > 0 &&
                <LineChart
                    xAxis={[{
                        scaleType: "band",
                        data: cpMonths,
                        label: "Month",
                        tickLabelStyle: { fontWeight: 'bold' },
                        categoryGapRatio: 0.4,
                    }]}
                    series={filteredMonthlyTrendsDataPoints}
                    grid={{ horizontal: true }}
                    // borderRadius={5}
                    height={250}
                    slotProps={
                        {
                            legend: {
                                itemGap: 5,
                                itemMarkHeight: 10,
                                itemMarkWidth: 10,
                                labelStyle: { fontSize: '0.8rem' }
                            }
                        }
                    }
                    sx={{
                        '& .MuiLineElement-series-goal': {
                            strokeDasharray: '6 4'
                        }
                    }}
                />
            }
        </Box>
    );

}

export default MonthlyTrendsChart;